import { InvoiceSearchResultModel } from "../Types";

export const InvoiceSearchModel: InvoiceSearchResultModel = {
  data: [],
  isError: false,
  isLoading: false,
};
